/* eslint-disable complexity */
import { Link } from '@chakra-ui/react';
import type { LinkProps } from '@chakra-ui/react';

type LinkComponentProps = LinkProps & {
	isNewTab?: boolean;
};

const LinkComponent = ({
	children, isNewTab, href, ...other
}: LinkComponentProps) => {
	const isHttpExternal = typeof href === 'string' && (href.startsWith('http://') || href.startsWith('https://'));

	const linkProps = {
		target:     isNewTab || isHttpExternal ? '_blank' : undefined,
		rel:        isNewTab || isHttpExternal ? 'noopener noreferrer' : undefined,
		isExternal: isHttpExternal,
		href,
		...other,
	};

	return (
		<Link as={'a'} textStyle={'p3'} {...linkProps}>
			{children}
		</Link>
	);
};

export default LinkComponent;